<template>
	<div class="floor-repeater">
		<div v-for="(floor, index) in form.floor" :key="index" class="form-repeater" :class="{'is-open': index === activeAccUnit}">
			<div class="floor-repeater__header">
				Floors
			</div>
			<div class="floor-repeater__wrap">
				<div class="floor-repeater__parent">
					<span class="floor-repeater__title" @click="showUnits(index)">
						Floor
						<span class="floor-repeater__number">(<span>5 </span> units)</span>
						<span>
							<SvgIcon class="floor-repeater__title-icon floor-repeater__title-icon--floor" iconName="ico-arrow-down"/>
						</span>
					</span>
					<button class="btn btn--mid btn--icon floor-repeater__unit-btn" @click="addUnit(index)">
						<SvgIcon class="btn-icon" iconName="ico-plus"/>
						<span>Add New Unit</span>
					</button>
				</div>
				<div class="floor-repeater__floor-inputs">
					<PartInputBasic class="floor-repeater__floor-input floor-repeater__floor-input--sm" v-model="floor.name" :data="DataFloor"/>
					<PartInputBasic class="floor-repeater__floor-input" v-model="floor.desc" :data="DataFloorDescription"/>
				</div>
				<slide-up-down :active="toggleAccUnits(index)" :duration="800">
					<transition name="fade">
						<div class="floor-repeater__units-inputs" v-if="floor != undefined">
							<div 
								v-for="(unit, indexUnits) in floor.units"
								:key="indexUnits"
								class="form-repeater form-repeater--unit"
								ref="singleUnit"
								:class="{'is-open': indexUnits === activeAccRoom}">
								
								<span class="form-repeater-border"></span>
								<span class="floor-repeater__title" @click="showAccRoom(indexUnits)">
									<span class="floor-repeater__title-num"><span>1</span></span>
										Unit
									<span class="floor-repeater__number">(<span>5 </span> rooms)</span>
									<span>
										<SvgIcon class="floor-repeater__title-icon floor-repeater__title-icon--unit" iconName="ico-arrow-down"/>
									</span>
								</span>
								<div class="floor-repeater__floor-input-unit">
									<PartInputBasic class="floor-repeater__floor-input floor-repeater__floor-input-unit-wrap" v-model="unit.description" :data="DataUnitDescription"/>
									<div  class="floor-repeater__floor-unit-input floor-repeater__floor-input-unit-wrap">
										<PartInputBasic class="floor-repeater__floor-input floor-repeater__floor-input--sm" v-model="unit.rent" :data="DataUnitRent"/>
										<div class="floor-repeater__floor-input floor-repeater__floor-input--checkbox">
											<div class="floor-repeater__floor-input-checkbox">
												<div class="checkbox-list">
													<div class="checkbox-list-item">
														<input type="radio" id="Vacant" name="radio_group" checked>
														<label class="checkbox-list__input" for="Vacant">Vacant</label>
													</div>
													<div class="checkbox-list-item">
														<input type="radio" id="Occupied" name="radio_group">
														<label class="checkbox-list__input" for="Occupied">Occupied</label>
													</div>
												</div>
											</div>
										</div>
									</div>
									<PartInputBasic class="floor-repeater__floor-input floor-repeater__floor-input-unit-wrap" v-model="unit.information" :data="DataLeaseInformation"/>
								</div>
								<slide-up-down :active="toggleAccRooms(indexUnits)" :duration="800">
									<div class="floor-repeater__rooms-inputs">
										<span class="floor-repeater__title" v-if="showUnit">
											Rooms
										</span>
										<div class="floor-repeater__floor-input-rooms" v-for="(room, indexRoom) in unit.rooms" :key="indexRoom" ref="singleRoom">
											<span class="floor-repeater__floor-input-rooms-num"><span>{{ indexRoom + 1 }}</span></span>
											<PartInputBasic class="floor-repeater__floor-input floor-repeater__floor-input--sm" v-model="room.roomNr" :data="DataNr"/>
											<PartCheckboxDropdown class="floor-repeater__floor-input floor-repeater__floor-input--lg" v-model="room.roomType" :data="DataType"/>
											<PartInputBasic class="floor-repeater__floor-input floor-repeater__floor-input--xl" v-model="room.roomDescription" :data="DataDetail"/>
											<div>
												<a @click="deleteRoom(index, indexUnits, indexRoom)" class="room-delete" href="javascript:;">
													<SvgIcon class="room-delete-icon" iconName="ico-delete"/>
												</a>
											</div>  
										</div>
										<a class="floor-repeater__floor-input-rooms-new" @click="addRoom(index, indexUnits)" href="javascript:;">
											<SvgIcon class="floor-repeater__floor-input-rooms-new-icon" iconName="ico-plus"/>
											Add New Room
										</a>    
									</div>
								</slide-up-down>
							</div>
						</div>
					</transition>
				</slide-up-down>
				<button class="btn btn--mid btn--icon floor-repeater__unit-btn" @click="addUnit(index)">
					<SvgIcon class="btn-icon" iconName="ico-plus"/>
					<span>Add New Unit</span>
				</button>
			</div>
		</div>
		<button class="btn btn--mid btn--icon floor-repeater-btn" @click="addNewFloor">
			<SvgIcon class="btn-icon" iconName="ico-plus"/>
			<span>Add New Floor</span>
		</button>
	</div>
</template>
<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import { mixin as onClickOutside } from 'vue-on-click-outside';
import PartInputBasic from '@/components/parts/PartInputBasic';
import PartCheckboxDropdown from '@/components/parts/PartCheckboxDropdown';
import SlideUpDown from 'vue-slide-up-down';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	components: {
		SvgIcon,
		PartInputBasic,
		PartCheckboxDropdown,
		SlideUpDown
	},
	data() {
		return {
			choices: [],
			allUnits: true,
			index: null,
			activeAccUnit: false,
			activeAccRoom: true,
			indexUnits: null,
			items: [
				{
					roomNr: '',
					roomType: '',
					description: ''
				}
			],
			form: {
				floor: [
					{
						name: '',
						desc: '',
						units: []
					}
				]
			},
			rents: [
				{
					for: 'Vacant',
					id: 'Vacant',
					name: 'Vacant',
					checked: false,
					value: 'Vacant',
					type: 'checkbox'
				},
				{
					for: 'Occupied',
					id: 'Occupied',
					name: 'Occupied',
					checked: false,
					value: 'Occupied',
					type: 'checkbox'
				}
			],
			checked: 0,
			DataFloor: {
				label: 'Floor',
				placeholder: 'Enter Number',
				classinput: 'small-inputs',
				inputId: 'floor-input',
				labelId: 'floor-label',
				mandatoryFiled: false
			},
			DataFloorDescription: {
				label: 'Floor Description',
				placeholder: 'Enter Description',
				classinput: '',
				inputId: 'floor_desc-input',
				labelId: 'floor_desc-label',
				mandatoryFiled: false
			},
			DataUnitDescription: {
				label: 'Description',
				placeholder: 'Enter Description',
				classinput: '',
				inputId: 'unit_desc-input',
				labelId: 'unit_desc-label',
				mandatoryFiled: false
			},
			DataUnitRent: {
				label: 'Rent',
				placeholder: 'Enter Number',
				classinput: '',
				inputId: 'unit_rent-input',
				labelId: 'unit_rent-label',
				mandatoryFiled: false
			},
			DataLeaseInformation: {
				label: 'Lease Information',
				placeholder: 'Enter Information',
				classinput: '',
				inputId: 'unit_information-input',
				labelId: 'unit_information-label',
				mandatoryFiled: false
			},
			DataCheckbox: {
				label: '',
				labelId: 'checkbox-rent',
				lists: [
					{
						id: 'checkbox_rent',
						checked: 'false',
						value: 'checkbox-rent',
						for: 'checkbox-rent',
						label: ''
					}
				]
			},
			// 
			DataNr: {
				label: 'No',
				placeholder: 'Enter Number',
				classinput: '',
				inputId: 'room_nr-input',
				labelId: 'room_nr-label',
				mandatoryFiled: false
			},
			DataType: {
				label: 'Type',
				placeholder: 'Add Type',
				classinput: '',
				inputId: 'room_type-input',
				labelId: 'room_type-label',
				mandatoryFiled: false,
				multiple: true,
				options: []
			},
			DataDetail: {
				label: 'Details',
				placeholder: 'Enter Details',
				classinput: '',
				inputId: 'room_details-input',
				labelId: 'room_details-label',
				mandatoryFiled: false
			},
			showUnit: false
		};
	},
	mixins: [onClickOutside],
	methods: {
		addNewFloor () {
			this.form.floor.push(
				{
					name: '',
					desc: '',
					units: []
				}
			);
		},
		addUnit (indexUnits, index) {			
			this.form.floor[indexUnits].units.push({
				description: '',
				checkbox: '',
				rent: '',
				information: '',
				rooms: [
					{
						roomNr: '',
						roomType: '',
						description: ''
					}
				]
			});
			this.showUnit = true;
			return this.activeAccUnit === index;
		},
		addRoom(indexFloor, indexUnit) {
			this.form.floor[indexFloor].units[indexUnit].rooms.push({
				roomNr: '',
				roomType: '',
				description: ''
			});
		},
		deleteRoom(indexFloor, indexUnit, indexRoom) {
			this.form.floor[indexFloor].units[indexUnit].rooms.splice(indexRoom);
		},
		showUnits(index) {
			if (this.form.floor.[index].units.length > 0) {
				if (this.activeAccUnit === index) {
					this.activeAccUnit = null;
				} else {
					this.activeAccUnit = index;
				}
			}
		},
		toggleAccUnits(index) {
			return index === this.activeAccUnit;
		},
		showAccRoom(indexUnits) {
			if (this.activeAccRoom === indexUnits) {
				this.activeAccRoom = null;
				this.showRoomsNum = true;
			} else {
				this.activeAccRoom = indexUnits;
				this.showRoomsNum = false;
			}
		},
		toggleAccRooms(indexUnits) {
			return indexUnits === this.activeAccRoom;
		}
	}
};
</script>
<style lang="scss" scoped>
.floor-repeater {
	margin-bottom: 40px;

	@include mq($lg) {
		margin-bottom: 20px;
	}
}

.form-repeater {
	line-height: 20px;
	padding-bottom: 20px;

	&.is-open {
		.floor-repeater__title-icon--floor {
			transform: rotate(180deg);
		}
		.form-repeater--unit {
			&:first-of-type {
				.form-repeater-border {

					&::before {
						opacity: 0.5;
					}
				}
			}
		}

		.floor-repeater__parent {
			.floor-repeater__number {
				display: none;
			}
		}

		.floor-repeater__floor-inputs::before {
			opacity: 0.5;
		}

		.form-repeater--unit::before {
			opacity: 0.5;
		}

		.form-repeater--unit::after {
			opacity: 0.5;
		}
	}

	&--unit {
		padding-left: 68px;
		position: relative;

		@include mq($xl) {
			padding-left: 50px;
		}

		@include mq($lg) {
			padding-left: 30px;
		}

		@include mq($md) {
			padding-left: 25px;
		}

		@include mq(390px) {
			padding-left: 15px;
		}
		
		&.is-open {
			.floor-repeater__floor-input-unit::after,
			.floor-repeater__rooms-inputs::before {
				opacity: 0.5;
			}

			.floor-repeater__title-icon--unit {
				transform: rotate(180deg);
			}

			.floor-repeater__number {
				display: none;
			}
		}

		&::before {
			content: '';
			position: absolute;
			left: 0;
			top: 14px;
			height: 2px;
			background-color: #7A869A;
			width: 55px;
			opacity: 0;
			transition: $dur $ease;

			@include mq($xl) {
				width: 4%;
			}

			@include mq($md) {
				display: none;
			}
		}

		&::after {
			content: '';
			position: absolute;
			left: 0;
			top: 15px;
			height: 100%;
			background-color: #7A869A;
			width: 2px;
			opacity: 0;
			transition: $dur $ease;

			@include mq($md) {
				display: none;
			}
		}

		&:last-of-type {
			&::after {
				display: none;
			}
		}
	}
}

.floor-repeater__wrap {
	background-color: $athens-gray;
	margin-bottom: 30px;
	padding: 22px 30px;

	@include mq($md) {
		padding: 20px;
		margin-bottom: 15px;
	}

	@include mq($sm) {
		margin-bottom: 0;
	}
}

.btn-icon {
	margin-right: 5px;
	font-size: 14px;
	height: 17px;

	span {
		line-height: 1;
	}

	svg {
		height: 14px;
	}
}

.floor-repeater__parent {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.floor-repeater__floor-inputs {
	display: flex;
	width: 100%;
	padding-left: 50px;
	padding-top: 26px;
	align-items: center;
	position: relative;

	&::before {
		content: '';
		position: absolute;
		left: 16px;
		top: 6px;
		height: 115%;
		background-color: #7A869A;
		width: 2px;
		opacity: 0;
		transition: $dur $ease;

		@include mq($md) {
			display: none;
		}
	}

	@include mq($md) {
		padding-left: 25px;
		padding-top: 20px;
	}

	@include mq(390px) {
		padding-left: 15px;
	}

	@include mq($sm) {
		flex-direction: column;
	}
}

.floor-repeater__units-inputs {
	padding-left: 16px;
	padding-top: 9px;

	@include mq($md) {
		padding-left: 0;
		padding-top: 0;
	}
}

// .form-repeater-border {
// 	display: none;
// 	transition: $dur $ease;
// }

// .form-repeater--unit {
// 	&:first-of-type {
// 		.form-repeater-border {
// 			position: relative;
// 			display: block;

// 			&::before {
// 				content: '';
// 				position: absolute;
// 				left: -68px;
// 				top: -130px;
// 				height: 145px;
// 				background-color: #7A869A;
// 				width: 2px;
// 				opacity: 0;
// 				transition: $dur $ease;

// 				@include mq($lg) {
// 					left: -50px;
// 				}

// 				@include mq($md) {
// 					display: none;
// 				}
// 			}
// 		}
// 	}
// }

.floor-repeater__floor-unit-input {
	display: flex;
	width: 100%;
	align-items: center;

	@include mq($sm) {
		flex-direction: column;
	}
}

.floor-repeater__floor-input {
	width: 100%;
	&--sm {
		max-width: 133px;
		margin-right: 33px;
		
		@include mq($lg) {
			margin-right: 15px;	
		}

		@include mq($sm) {
			max-width: 100%;
			margin-right: 0;
		}
	}

	&--lg {
		max-width: 264px;
		margin-right: 33px;
		position: relative;
		display: block;
		min-width: 264px;

		@include mq($lg) {
			margin-right: 15px;
			min-width: 200px;
		}

		@include mq($sm) {
			max-width: 100%;
			margin-right: 0;
		}
	}

	&--checkbox {
		margin-bottom: 0;
		
		@include mq($sm) {
			margin-bottom: 20px;
		}
	}
}

.floor-repeater__floor-input-unit-wrap {
.floor-repeater__floor-input--sm {
    margin-right: 15px;
	min-width: 70px;

	@include mq($md) {
		margin-right: 0;
	}
}
	&:not(:last-of-type) {
		margin-right: 10px;

		@include mq($md) {
			margin-right: 0;
		}
	}
}

.floor-repeater__title {
	font-family: $font-main;
	font-weight: 500;
	font-size: 18px;
	line-height: 22px;
	color: $fiord;
	display: flex;
	align-items: center;
	cursor: pointer;

	@include mq($lg) {
		font-size: 16px;
	}
}

.room-delete {
	padding: 0 22px;

	@include mq($lg) {
		padding: 0 0 0 10px;
	}

	@include mq($lg) {
		padding: 0;
		position: absolute;
		top: 0;
		right: 0;
	}

	@include hover {
		.room-delete-icon {
			color: $red;
		}
	}
}

.room-delete-icon {
	color: $dodger-blue;
}

.floor-repeater__title-icon {
	font-size: 30px;
	display: block;
	color: $fiord;
	margin-left: 4px;
	transition: $dur $ease;

	@include mq($lg) {
		font-size: 25px;
	}
}

.floor-repeater__header {
	font-family: $font-main;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	color: $white;
	background-color: $fiord;
	padding: 13px 12px;
	display: flex;

	@include mq($lg) {
		margin-bottom: 20px;
	}

	@include mq($sm) {
		margin-bottom: 0;
	}
}

.floor-repeater__floor-input-checkbox {
	display: flex;
	align-items: center;
}

.checkbox-list {
	padding-left: 4px;
	display: flex;
	align-items: center;
}

.checkbox-list__input {
	font-family: $font-main;
	font-size: 14px;
	line-height: 20px;
	color: $fiord;
	margin-right: 10px;
	transition: $dur $ease;
	display: flex;
	cursor: pointer;
}

[type="radio"]:checked,
[type="radio"]:not(:checked) {
	position: absolute;
	left: -9999px;
}

[type="radio"]:checked + label,
[type="radio"]:not(:checked) + label
{
	position: relative;
	padding-left: 34px;
	cursor: pointer;
	line-height: 20px;
	display: inline-block;
	color: #666;
}

[type="radio"]:checked + label:before,
[type="radio"]:not(:checked) + label:before {
	content: '';
	position: absolute;
	left: 4px;
	top: 0;
	width: 20px;
	height: 20px;
	border: 2px solid $alto;
	box-sizing: border-box;
	border-radius: 4px;
	background: $white;
	transition: $dur $ease;
}

[type="radio"]:checked + label:after,
[type="radio"]:not(:checked) + label:after {
	content: '';
	position: absolute;
	left: 11px;
	top: 4px;
	width: 6px;
	height: 10px;
	transition: $dur $ease;
	border: solid $white;
	border-width: 0 2px 2px 0;
	transform: rotate(45deg);
}

[type="radio"]:not(:checked) + label:after {
	opacity: 0;
	transform: scale(0);
}

[type="radio"]:checked + label:after {
	opacity: 1;
	transform: scale(1) rotate(45deg);
}

[type="radio"]:checked + label:before {
	background: $dodger-blue;
}

.checkbox-list-item {
	&:not(:last-of-type) {
		margin-right: 31px;

		@include mq(1600px) {
			margin-right: 15px;
		}
	}
}

.checkbox-list__label {
	margin-bottom: 0;
	font-size: 14px;
	padding-left: 28px;

	@include mq($xl) {
		display: flex;
		align-items: center;
	}
}

.floor-repeater__title-num {
	font-family: $font-main;
	font-weight: 500;
	font-size: 14px;
	line-height: 17px;
	color: $white;
	padding: 3.5px 9px;
	background-color: $dodger-blue;
	border-radius: 50%;
	display: block;
	margin-right: 16px;
	position: relative;
	height: 24px;
	width: 24px;

	@include mq($lg) {
		margin-right: 10px;
		padding: 0 5px;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 20px;
		width: 20px;
		font-size: 12px;
	}

	span {
		top: 50%;
		position: absolute;
		left: 50%;
		transform: translate(-50%, -50%);
	}
}

.floor-repeater__floor-input-rooms {
	display: flex;
	align-items: center;
	padding-top: 16px;
	position: relative;

	@include mq($sm) {
		flex-direction: column;
	}

	&:first-of-type {
		.room-delete {
			display: none;
		}
	}
}

.floor-repeater__rooms-inputs {
	padding-left: 45px;
	margin-left: 14px;
	position: relative;

	@include mq($lg) {
		padding-left: 30px;	
	}

	@include mq($md) {
		padding-left: 20px;	
	}

	&::before {
		content: '';
		position: absolute;
		left: 0;
		top: 9px;
		height: 2px;
		background-color: #7A869A;
		width: 30px;
		opacity: 0;
		transition: $dur $ease;

		@include mq($lg) {
			width: 4%;
		}
		
		@include mq($md) {
			display: none;
		}
	}
}

.floor-repeater__number {
	font-family: $font-main;
	font-size: 14px;
	line-height: 1.1;
	margin: 0 -3px 0 9px;
	color: $shuttle-gray;
	display: flex;
	transition: $dur;
	span {
		margin-right: 3px;
	}
}

.floor-repeater__floor-input-unit {
	padding: 30px 0 10px 28px;
	margin-left: 14px;
	position: relative;
	display: flex;

	@include mq($md) {
		padding: 20px 0 10px 15px;
		flex-direction: column;
	}

	@include mq(390px) {
		padding: 10px 0;
	}

	&::after {
		content: '';
		position: absolute;
		left: 0;
		top: 11px;
		height: 100%;
		background-color: #7A869A;
		width: 2px;
		opacity: 0;
		transition: $dur $ease;

		@include mq($md) {
			display: none;
		}
	}
}

.floor-repeater__floor-input-rooms-num {
	font-family: $font-main;
	font-weight: 500;
	font-size: 14px;
	line-height: 17px;
	color: $dodger-blue;
	border: 2px solid $dodger-blue;
	border-radius: 50%;
	display: block;
	padding: 1.5px 7px;
	margin-right: 20px;
	z-index: 9;

	@include mq($lg) {
		margin-right: 10px;
		padding: 0 5px;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 20px;
		width: 20px;
		font-size: 12px;
	}

	@include mq($sm) {
		position: absolute;
		left: -30px;
		top: 0;
		margin: 0;

		span {
			top: 50%;
			position: absolute;
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}
}

.floor-repeater__floor-input-rooms-new {
	font-family: $font-main;
	font-size: 16px;
	line-height: 20px;
	color: $dodger-blue;
	display: flex;
	align-items: center;
	margin-left: 42px;
	width: fit-content;

	@include mq($xl) {
		margin-left: 15px;
		font-size: 14px;
	}

	@include mq($lg) {
		margin-left: 0;
		margin-top: 0;
	}
}

.floor-repeater__floor-input-rooms-new-icon {
	font-size: 7px;
	margin-right: 3px;
}

.floor-repeater-btn {
	margin-top: 42px;

	@include mq($md) {
		min-width: 150px;
	}

	@include mq($lg) {
		margin-top: 20px;
	}
}

.floor-repeater__unit-btn {
	@include mq($md) {
		min-width: 130px;
	}
}
</style>
